import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { paymentTypeShape } from "app/utils/propTypes";
import PaymentDescriptionTerms from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTerms";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import { isBookingDateEligibleForDeposit } from "app/pages/Booking/bookingSelectors";

const PaymentDescriptionTermsContainer = props => {
	return <PaymentDescriptionTerms {...props} />;
};
const mapStateToProps = state => {
	return {
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		onlinePercentage: getPartnerDepositPercentage(state),
	};
};
PaymentDescriptionTermsContainer.propTypes = {
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
	enableDepositDisplay: PropTypes.bool,
	onlinePercentage: PropTypes.number,
};

export default connect(mapStateToProps)(PaymentDescriptionTermsContainer);
